import { createReducer, on } from '@ngrx/store';
import { getModifaceConfig } from '../actions/modiface-config.actions';
import { ModifaceConfig } from '../networking/models/modiface/modiface-config';

export interface StateModifaceConfig {
    data: ModifaceConfig;
}

export const initialState: StateModifaceConfig = {
  data: {
    enableWeb: false,
    enableIos: false,
    enableAndroid: false,
    info: "enable o disable Modiface in each front",
    objectID: "MODIFACE.CONFIGURATION.FLAG",
    cache_web_by_hours: 12.0,
  },
}

const _modifaceConfigReducer = createReducer(initialState,
  on(getModifaceConfig, (state, { data }) => ({ ...state, data: {...data} })),
);

export function modifaceConfigReducer(state, action) {
  return _modifaceConfigReducer(state, action);
}
